import { put, takeEvery, all } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { showNotification } from 'react-admin';

function* clusterChangeSuccess() {
  yield put(showNotification('Cluster type changed'));
  yield put(push('/clusters'));
}

function* clusterChangeFailure({ error }) {
  yield put(showNotification('Error: Cluster type not changed', 'warning'));
  console.error(error);
}

export default function* commentSaga() {
  yield all([
    takeEvery('CLUSTER_CHANGE_TYPE_SUCCESS', clusterChangeSuccess),
    takeEvery('CLUSTER_CHANGE_TYPE_FAILURE', clusterChangeFailure),
  ]);
}



// WEBPACK FOOTER //
// ./src/resources/clustersSaga.js